module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA1CAYAAADh5qNwAAAAAXNSR0IArs4c6QAAALJJREFUaEPtmrENg0AUxcIGd/sPeSMQiSJNKktIJhdTP8l8m5JjjHG+NnuOrY9aa/18rznndcOnVEc9tGmlHhrm67UqVSnRQJ+fKB+hK4V0ieNKifIRulJIlziulCgfoSuFdInjSonyEbpSSJc4rpQoH6ErhXSJ40qJ8hG6UkiXOK6UKB+hK4V0ieNKifIRulJIlziulCgfoSuFdInjSonyEbpSSJc4/o9SouDb0Vv+bvoGV+LR8VyqeY4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/one-to-one.png
// module id = btFX
// module chunks = 3